import dynamic from "next/dynamic";
import { HomePageContent } from "../../../../pages";


const DynamicSection = dynamic(() => import("../../../Common/DynamicSection"), {
  ssr: false,
});
function ClientSection({htmlContent}: { htmlContent: HomePageContent["htmlContent"] }) {
  const sectionContent = htmlContent;

  if (
    !sectionContent ||
    (sectionContent && !Object.keys(sectionContent)?.length)
  ) {
    return <></>;
  }

  if (Array.isArray(sectionContent) && !!sectionContent.length) {
    return (
      <>
        {sectionContent.map((content, index) => (
          <DynamicSection key={index} content={content} />
        ))}
      </>
    );
  }

  if (Object.values(sectionContent).every((val) => !val)) {
    return <></>;
  }

  return (
    <DynamicSection content={sectionContent as { html: string; css: string }} />
  );
}

export default ClientSection;